import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var optionValueSchema = {
    value: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Value *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валиднa стойност',
    }),
};
export default optionValueSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/optionValueSchema.ts
// module id = 382
// module chunks = 0